import type { FaireProductEntity } from "../../entity_types/product";

export const p_7hbzh6jg98: FaireProductEntity = {
  token: "p_7hbzh6jg98",
  type: "product",
  name: "Juniper Coupe / Martini / Cocktail Glass / Set of 2",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/863bec4b95c906a5e1da6658203e78d58110bd9dc42586a90b097cfa430c1c45.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1a51942364731e7828af56aa7f575813efe7144d4d0914601a2fd6f579ca355c.jpeg",
  ],
  priceDollars: 26.25,
  description:
    'Juniper is a sculptural glassware range designed to elevate the drinking experience by enhancing both flavour and aroma. The glasses are graphic in form yet functional and satisfying to use, and their striking geometric silhouette adds interest to any table, bar or drinks trolley.\n\nJuniper Coupe / Martini / Cocktail Glass\nDimension: Ø 10.3cm x H 15cm / Ø 4" x H 5.9"\nCapacity: 220ml / 7.5 fl oz\n\nPacked as a set of 2\n\nColour: clear',
  tags: [],
  msrpDollars: 52.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:31.512Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
